import DOMPurify from 'dompurify';

/**
 * @param data argument that needs to be sanitized
 * @description function to generate a sanitized string
 * @function
 * @returns {string} returns a sanitized string
 */
const Harpic = (data) => `${DOMPurify.sanitize(data)}`;
/**
 * @function
 * @description generate a random number
 * @returns {number} returns a randomized number
 */
const generateRandomNumber = (numb = 9999999999) => Math.ceil(Math.random() * numb);
/**
 *
 * @param element input element node to be checked for
 * @param extensions array of compatible extensions
 * @param size size limit
 * @function
 * @description checks the file input element's file type n size (optional) against whats given
 * @return {Boolean} returns whether it satisfies the condition given or not
 */
const fileInputChecker = (element, extensions, size) => extensions.some(ext => {
    if (size) {
        return element.type.match(ext) && element.size < size;
    }
    return element.type.match(ext);
});
/**
 *
 * @param str date string
 * @function
 * @description generate a Date object from a date string, useful for Safari
 * @return {Date} a Date object from a date string, useful for Safari
 */
const dateFromString = (str) => {
    const a = str.split(/[^0-9]/).map(s => parseInt(s, 10));
    return new Date(a[0], a[1] - 1 || 0, a[2] || 1, a[3] || 0, a[4] || 0, a[5] || 0, a[6] || 0);
};
/**
 *
 * @param whichDay pass the day number ()
 * @param month the month from which the day is needed
 * @param year the year of the month from which the day is needed
 * @description used for getting the date of a particular day of the month of a year.
 * 				<ul>
 * 				<li>Sunday - 0</li>
 * 				<li>Monday - 1</li>
 * 				<li>Tuesday - 2</li>
 * 				<li>Wednesday - 3</li>
 * 				<li>Thursday - 4</li>
 * 				<li>Friday - 5</li>
 * 				<li>Saturday - 5</li>
 * 				</ul>
 *	@returns {Date} the date object of the particular day in qn
 *
 */
const getDateFromDayOfMonth = (whichDay, month, year) => {
    const date = new Date(year, month + 1, 1, 0, 0, 0, 0);
    date.setDate(whichDay - date.getDay());
    return date;
};
/**
 * @function
 * @param {string | number} value send the number which needs to be converted to normal number
 * @returns {string}
 * @description returns a normal number (`string`) of a scientific number (one with exponents etc)
 */
const scientificToDecimal = (value) => {
    let number = String(value);
    const numberHasSign = number.startsWith('-') || number.startsWith('+');
    const sign = numberHasSign ? number[0] : '';
    number = numberHasSign ? number.replace(sign, '') : number;
    // if the number is in scientific notation remove it
    if (/\d+\.?\d*e[+-]*\d+/i.test(number)) {
        const zero = '0';
        const parts = String(number).toLowerCase().split('e'); // split into coeff and exponent
        const e = Number(parts.pop()); // store the exponential part
        let l = Math.abs(e); // get the number of zeros
        const sign2 = e / l;
        const coeffArray = parts[0].split('.');
        if (sign2 === -1) {
            coeffArray[0] = `${Math.abs(+coeffArray[0])}`;
            number = `${zero}.${new Array(l).join(zero)}${coeffArray.join('')}`;
        }
        else {
            const dec = coeffArray[1];
            if (dec) {
                l -= dec.length;
            }
            number = coeffArray.join('') + new Array(l + 1).join(zero);
        }
    }
    return `${sign}${number}`;
};
/**
 * @type function
 * @param val the `number/string` that needs to be trimmed decimally
 * @param floatPlaces the number of decimal precision required `default = 2`
 * @returns {string} trimmed numerical string based on the floatplaces passed
 * @description returns a number trimmed to a no. of decimals in string format without any rounding off
 */
const decimalTrimmer2 = (val, floatPlaces = 2) => {
    const re = new RegExp(`^-?\\d*(?:.\\d{0,${floatPlaces || -1}})?`);
    const newVal = scientificToDecimal(val);
    return newVal.match(re) ? newVal.match(re)[0] : newVal;
};
/**
 * @type function
 * @param val the `number/string` that needs to be trimmed decimally
 * @param floatPlaces the number of decimal precision required `default = 2`
 * @returns {Number | String} trimmed number based on the floatplaces passed
 * @description returns a number trimmed to a no. of decimals in string format without any rounding off
 */
const decimalTrimmer = (val, floatPlaces = 2) => {
    if (val === '') {
        return '';
    }
    const tens = 10 ** floatPlaces;
    return Math.floor(+scientificToDecimal(val) * tens) / tens;
};
/**
 * @type function
 * @param {Number} ms accepts `number`.
 * @description send the amount of delay this function has to create in milliseconds
 */
const waitMaadi = (ms) => new Promise(r => setTimeout(r, ms));
/**
 *
 * @param {Object} obj `object` the object whose key you want to check
 * @param {String} prop `string` the key/parameter that you want to check if it exists
 * @returns `Boolean`
 * @description to check if an object has a key or not
 */
const hasOwn = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
// export function debounceOld(
// 	func: () => any,
// 	wait: number,
// 	immediate: Boolean
// ): () => void {
// 	let timeout: NodeJS.Timeout | null;
// 	return function debouncerReturner(this: any, ...args) {
// 		const context = this;
// 		const later = function () {
// 			timeout = null;
// 			if (!immediate) {
// 				func.apply(context, args);
// 			}
// 		};
// 		const callNow = immediate && !timeout;
// 		if (timeout) {
// 			clearTimeout(timeout);
// 		}
// 		timeout = setTimeout(later, wait);
// 		if (callNow) {
// 			func.apply(context, args);
// 		}
// 	};
// }
/**
 * @description a function for debouncing functions
 * @param {Function} func function that needs to be debounced
 * @param {Number} wait wait time in milliseconds
 * @param {Boolean} immediate whether the function needs to be fired first or later
 */
function debounce(func, wait, immediate) {
    // 'private' variable for instance
    // The returned function will be able to reference this due to closure.
    // Each call to the returned function will share this common timer.
    let timeout;
    // Calling debounce returns a new anonymous function
    return function (...args) {
        // reference the context and args for the setTimeout function
        const context = this;
        // Should the function be called now? If immediate is true
        //   and not already in a timeout then the answer is: Yes
        const callNow = immediate && !timeout;
        // This is the basic debounce behaviour where you can call this
        //   function several times, but it will only execute once
        //   [before or after imposing a delay].
        //   Each time the returned function is called, the timer starts over.
        if (timeout) {
            clearTimeout(timeout);
        }
        // Set the new timeout
        timeout = window.setTimeout(() => {
            // Inside the timeout function, clear the timeout variable
            // which will let the next execution run when in 'immediate' mode
            timeout = null;
            // Check if the function already ran with the immediate flag
            if (!immediate) {
                // Call the original function with apply
                // apply lets you define the 'this' object as well as the arguments
                //    (both captured before setTimeout)
                func.apply(context, args);
            }
        }, wait);
        // Immediate mode and no wait timer? Execute the function..
        if (callNow) {
            func.apply(context, args);
        }
    };
}
/**
 * @description return a comma separated version readable version of a number
 * @param {number | string} value value that you want to convert to a comma separated number
 * @param {Number} min minimum decimal places
 * @param {Number} max maximum decimal places
 * @param {Number} type comma interval to follow after 1000th place. default follows International standard of 3 i.e. 1,000,000,000 types. if its 2, then you will get 1,00,00,00,000
 * @returns `string`
 */
const intNumberConverter = (value, min = 0, max = 2, intervalAfterThousand = 3) => {
    let number;
    if (!value || Number.isNaN(value)) {
        number = '0';
    }
    else {
        number = value.toString();
    }
    const shortNumber = decimalTrimmer2(number, min);
    if (max) {
        number = decimalTrimmer2(number, max);
        if (number === shortNumber) {
            number = shortNumber;
        }
    }
    else {
        number = shortNumber;
    }
    number = number.toString();
    let afterPoint = '';
    if (number.indexOf('.') > 0) {
        afterPoint = number.substring(number.indexOf('.'), number.length);
        if (afterPoint.length - 1 < min) {
            afterPoint += '0'.repeat(min - (afterPoint.length - 1));
        }
    }
    else if (min > 0) {
        afterPoint = `.${'0'.repeat(min)}`;
    }
    number = Math.floor(+number);
    number = number.toString();
    let lastThree = number.substring(number.length - 3);
    const otherNumbers = number.substring(0, number.length - 3);
    if (otherNumbers !== '') {
        lastThree = `,${lastThree}`;
    }
    const res = otherNumbers.replace(new RegExp(`\\B(?=(\\d{${intervalAfterThousand}})+(?!\\d))`, 'g'), ',') +
        lastThree +
        afterPoint;
    return res;
};
/**
 * @description return a comma separated India specific formatted readable version of a number
 * @param {number | string} value value that you want to convert to a comma separated number
 * @param {Number} min minimum decimal places
 * @param {Number} max maximum decimal places
 * @returns `string`
 */
const inrConverter = (value, min, max) => intNumberConverter(value, min, max, 2);
/**
 * @description return a comma separated India specific formatted readable version of a number
 * @param {Number | String} val value that you want to convert to a comma separated number
 * @param {Object} MoneyFormatterOptions : object with the following options
 * @param {String} locale Locale to which the number should be formatted to
 * @param {Number} min minimum decimal places
 * @param {Number} max maximum decimal places
 * @returns `string`
 */
const moneyFormatter = (val, { locale = 'en-IN', min, max } = {}) => {
    const absoluteVal = Math.abs(+val);
    const sign = val < 0 ? '-' : '';
    const minimum = min || 0;
    const maximum = Number.isFinite(max)
        ? max
        : Number.isFinite(absoluteVal) && absoluteVal <= 10
            ? 4
            : 2;
    if (locale === 'en-IN') {
        return `${sign}${intNumberConverter(absoluteVal, minimum, maximum, 2)}`;
    }
    if (locale === 'en-US') {
        return `${sign}${intNumberConverter(absoluteVal, minimum, maximum, 3)}`;
    }
    return val
        ? val.toLocaleString(locale, {
            minimumFractionDigits: minimum,
            maximumFractionDigits: maximum,
        })
        : '0';
};
/**
 * @description used to give if a semantic version is greater, lesser or equal
 * @returns {Number} `number`
 * @param {String} ver1 version to compare with
 * @param {String} ver2 version to compare with
 */
const compareVersion = (ver1, ver2) => {
    if (typeof ver1 !== 'string')
        return false;
    if (typeof ver2 !== 'string')
        return false;
    const v1 = ver1.split('.');
    const v2 = ver2.split('.');
    const k = Math.min(v1.length, v2.length);
    for (let i = 0; i < k; ++i) {
        v1[i] = parseInt(v1[i], 10);
        v2[i] = parseInt(v2[i], 10);
        if (v1[i] > v2[i])
            return 1;
        if (v1[i] < v2[i])
            return -1;
    }
    return v1.length === v2.length ? 0 : v1.length < v2.length ? -1 : 1;
};
/**
 * @description to generate a qrcode url
 * @param {String | Number} val value that needs to be converted to a qr code
 * @param {Number} size size of the qr code that needs to be generated
 * @returns {string} `string`
 */
const generateQrCode = (val, size = 120) => `https://chart.googleapis.com/chart?cht=qr&chs=${size}x${size}&chld=L|0&chl=${val}`;
// `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=0&data=${val}`;
/**
 * @description used for calling async functions in array loops
 * @param array array that needs to be iterated
 * @param callback the async callback function within which the array item needs to be called
 */
const asyncForEach = async (array, callback) => {
    /**
     * reference: https://codeburst.io/javascript-async-await-with-foreach-b6ba62bbf404
     */
    for (let index = 0; index < array.length; index += 1) {
        await callback(array[index], index, array);
    }
};
/**
 * @description to memoize functions
 * @param func function that needs to be memoized
 */
const memoized = (func) => {
    const cache = {};
    return (...args) => {
        const stringifiedArgs = JSON.stringify(args);
        const whatToReturn = cache[stringifiedArgs] || (cache[stringifiedArgs] = func(...args));
        return whatToReturn;
    };
};
/**
 * @description function to convert camelcase to normal sentence
 * @param text camelcased string that needs to be converted to sentence
 * @returns `string`
 */
const camelToSentence = (text = '') => {
    if (typeof text !== 'string') {
        return text;
    }
    const pos = [0];
    let word = '';
    text.split('').forEach((ch, index) => {
        if (ch === ch.toUpperCase()) {
            pos.push(index);
        }
    });
    pos.forEach((p, index) => {
        const nextPos = index + 1 === pos.length ? text.length : pos[index + 1];
        word = `${word} ${text.slice(p, nextPos)}`;
    });
    return word.trim();
};
/**
 * @description send a time and get the text with difference in seconds, minutes, hours or days
 * @returns `string`
 * @param time Date object, string or number with the javascript time
 * @param maxDays set max no. of days for showing `so.so. Days ago`
 */
const checkSMHD = (time, maxDays = 1) => {
    const diff = Math.trunc((Date.now() - new Date(time).getTime()) / 1000);
    if (diff < 5) {
        return 'Moments ago'; // less than 5s
    }
    if (diff < 60) {
        return `${diff} second${(diff !== 1 && 's') || ''} ago`; // Seconds ago
    }
    if (diff < 3600) {
        const calcDiff = Math.trunc(diff / 60);
        return `${calcDiff} Minute${(calcDiff !== 1 && 's') || ''} ago`; // Minutes ago
    }
    if (diff < 86400) {
        const calcDiff = Math.trunc(diff / (60 * 60));
        return `${calcDiff} Hour${(calcDiff !== 1 && 's') || ''} ago`; // Hours ago
    }
    if (diff < 86400 * maxDays) {
        const calcDiff = Math.trunc(diff / (60 * 60 * 24));
        return `${calcDiff} Day${(calcDiff !== 1 && 's') || ''} ago`; // Days ago upto 5
    }
    return '';
};
/**
 * @description used to measure time taken(performance) by a function
 * @param cb
 * @param args
 */
const measureTime = (cb, ...args) => {
    const t0 = performance.now();
    cb(...args);
    const t1 = performance.now();
    console.log(`Call to doSomething took ${t1 - t0} milliseconds`);
};

const checkDocument = typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined';
/**
 * @description function for requestIdleCallback with fallbacks
 * @param {any} cb - callback function
 * @param {Number} timeout - time in milliseconds
 */
const requestIdleCb = (cb, timeout) => {
    if (checkDocument) {
        if (typeof window.requestIdleCallback !== 'undefined') {
            return window.requestIdleCallback(cb, timeout ? { timeout } : undefined);
        }
        if (typeof window.requestAnimationFrame !== 'undefined') {
            return window.requestAnimationFrame(cb);
        }
        return window.setTimeout(cb, 16);
    }
    return cb();
};
/**
 * @type Function
 * @description A function that helps in getting a param's value in the url
 * @param {String} param the param who's value needs to be determined from a url
 * @param {String} url (optional) the url in which the param will be checked for. `window.location.search` is taken as `default`
 * @returns string | null
 */
const GetURLParams = (param, url) => {
    if (checkDocument) {
        const link = url || window.location.search;
        if (typeof URLSearchParams === 'undefined') {
            const name = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
            const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
            const results = regex.exec(link);
            return results === null
                ? null
                : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }
        return new URLSearchParams(link).get(param);
    }
    return null;
};
/**
 * @type string | null
 * @description returns the userAgent string of the browser/whatever is in use.
 * @returns {string | null} string or null
 */
const userAgent = checkDocument
    ? navigator.userAgent || navigator.vendor || window.opera
    : null;
/**
 * @type string | null
 * @description Returns the Operating system of the mobile device in use (`iOS`, `Android`, `bhindoj` for windows and false for neither)
 * @returns {string | null} string or null
 */
const getMobileOperatingSystem = checkDocument &&
    userAgent &&
    (/(iPad|iPhone|iPod)/i.test(userAgent)
        ? 'iOS'
        : /Android/i.test(userAgent)
            ? 'Android'
            : /Windows Phone/i.test(userAgent)
                ? 'bhindoj'
                : false);
/**
 * @type Function
 * @description A function that returns the browser name along with its version
 */
const getBrowserNVersion = () => {
    if (checkDocument) {
        const sayswho = (() => {
            const ua = navigator.userAgent;
            let tem;
            let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null) {
                    return tem.slice(1).join(' ').replace('OPR', 'Opera');
                }
            }
            M = M[2]
                ? [M[1], M[2]]
                : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                M.splice(1, 1, tem[1]);
            }
            return M.join(' ');
        })();
        return sayswho;
    }
    return null;
};
/**
 * @type closure
 * @description An object which handles creation, checking and removal of cookies.
 */
const CookieControl = {
    /**
     *
     * @param {string | number} name name of the cookie
     * @param {string | number} value value to be stored in the cookie
     * @param {Number} maxAge no. of seconds the cookie needs to be stored
     * @param {Number} expiry no. of days the cookie needs to be stored
     * @param {String} domain set a domain for the cookie. specifies which hosts are allowed to receive the cookie. If unspecified, it defaults to the same origin that set the cookie, excluding subdomains. https://javascript.info/cookie#domain
     * @param {Boolean} isSecure set `secure` for the cookie if requried
     * @param {String} path The url path prefix, the cookie will be accessible for pages under that path. Must be absolute. By default, it’s the current path. https://javascript.info/cookie#path
     * @description Used to Create a new cookie
     */
    createNew(name, value, { maxAge, expiry, domain, isSecure, path } = {}) {
        let expires = '';
        if (expiry) {
            expires = ` expires=${new Date(typeof expiry === 'number' ? expiry : dateFromString(expiry)).toUTCString()}`;
        }
        if (checkDocument) {
            document.cookie = `${name}=${value};${expires};${maxAge ? `max-age:${maxAge}` : ''} ${path ? `path=${path}; ` : ''}${domain ? `domain=${domain}; ` : ''}${isSecure ? 'secure; ' : ''}`;
        }
    },
    /**
     * @description to get the value of a cookie
     * @param name name of the cookie whose value u need
     */
    check(name) {
        const matches = document.cookie.match(new RegExp('(?:^|; )' +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
            '=([^;]*)'));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    /**
     * @description to remove a cookie
     * @param name name of the cookie which should be deleted
     */
    remove(name) {
        this.createNew(name, '', {
            maxAge: -1,
        });
    },
};
// export const kukeej = CookieControl();
/* ***************** new addition 1- event delegation ************ */
const isSame = checkDocument && document.body.isEqualNode ? 'isEqualNode' : 'isSameNode';
/**
 * @description Used for event delegation of multiple events to an child item with a classname inside a wrapper element
 * @param wrapperEl DOM instance of the wrapper element
 * @param eventName names of the events to be listened to separated by a space
 * @param delegatedElClass the classname of the element that needs delegation
 * @param action the function that needs to be called when the event is triggered on the delegatedElClass
 */
const delegateClass = (wrapperEl, eventName, delegatedElClass, action) => {
    eventName.split(' ').forEach(en => {
        wrapperEl.addEventListener(en.trim(), event => {
            let checkingNode = event.target;
            while (checkingNode) {
                if (checkingNode[isSame](wrapperEl)) {
                    // checking element itself
                    checkingNode = null; // STOP loop
                }
                else if (checkingNode.classList.contains(delegatedElClass)) {
                    // found delegated element
                    action.call(checkingNode, event); // "this" will be delegated el
                    checkingNode = null; // STOP loop
                }
                else {
                    // going to parent node
                    checkingNode = checkingNode.parentElement;
                }
            }
        });
    });
};
/**
 * @description Used for event delegation of multiple events to an child item with a classname inside a wrapper element
 * @param {HTMLElement} wrapperEl DOM instance of the wrapper element
 * @param {String} eventName names of the events to be listened to separated by a space
 * @param {String} delegateElSelector the selector string of the element that needs delegation
 * @param {Function} action the function that needs to be called when the event is triggered on the delegatedElClass
 */
const delegateSelector = (wrapperEl, eventName, delegateElSelector, action) => {
    eventName.split(' ').forEach(en => {
        wrapperEl.addEventListener(en.trim(), event => {
            let checkingNode = event.target;
            while (checkingNode) {
                if (checkingNode[isSame](wrapperEl)) {
                    // checking element itself
                    checkingNode = null; // STOP loop
                }
                else if (checkingNode.matches(delegateElSelector)) {
                    // found delegated element
                    action.call(checkingNode, event); // "this" will be delegated el
                    checkingNode = null; // STOP loop
                }
                else {
                    // going to parent node
                    checkingNode = checkingNode.parentElement;
                }
            }
        });
    });
};
/**
 * @type Function
 * @description A function which returns scroll bar width
 * @returns {number}
 */
const getScrollbarWidth = (() => {
    let memoWidth = NaN;
    return () => {
        if (checkDocument) {
            if (!Number.isNaN(memoWidth) && memoWidth !== null) {
                return memoWidth;
            }
            const scrollDiv = document.createElement('div');
            scrollDiv.className = 'scrollbar-measure';
            document.body.appendChild(scrollDiv);
            // Get the scrollbar width
            memoWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return memoWidth; // Mac:  151 the DIV
        }
        return 0;
    };
})();
/**
 * @type Function
 * @description A function which returns an object, which has properties that manage tab focus event.
 */
const TabFocusCheck = () => {
    const keys = {
        hidden: 'visibilitychange',
        mozHidden: 'mozvisibilitychange',
        msHidden: 'msvisibilitychange',
        webkitHidden: 'webkitvisibilitychange',
    };
    let visStateKey;
    let visEventKey;
    if (checkDocument) {
        visStateKey = Object.keys(keys).find(key => key in document);
        visEventKey = keys[visStateKey];
    }
    return {
        getVisStateKey: () => visStateKey,
        tabFocus: (fn) => {
            if (checkDocument) {
                if (fn) {
                    document.addEventListener(visEventKey, fn, false);
                }
                return !document[visStateKey];
            }
            return null;
        },
        removeFocusEvent: (fn) => {
            if (checkDocument) {
                document.removeEventListener(visEventKey, fn, false);
            }
        },
    };
};
/**
 * @type Function
 * @description A function that returns an object which has
 * properties to check online/offline status of the client and perform necessary actions.
 */
const checkOnlineStatus = () => {
    const onlineFns = [];
    const offlineFns = [];
    return {
        onOnline: (fn) => {
            if (checkDocument) {
                const newFn = ({ type }) => {
                    if (typeof fn === 'function') {
                        fn(type);
                    }
                };
                window.addEventListener('online', newFn);
                onlineFns.push(newFn);
            }
        },
        onOffline: (fn) => {
            if (checkDocument) {
                const newFn = ({ type }) => {
                    if (typeof fn === 'function') {
                        fn(type);
                    }
                };
                window.addEventListener('offline', newFn);
                onlineFns.push(newFn);
            }
        },
        resetAll: () => {
            onlineFns.forEach(fn => {
                window.removeEventListener('online', fn);
            });
            offlineFns.forEach(fn => {
                window.removeEventListener('offline', fn);
            });
        },
    };
};
const onlineStatusInstance = checkOnlineStatus();
/**
 *
 * @param {String} text
 * @param {string | string[]} LSKeys
 * @type Function
 * @description A function that removes a set of keys matching a pattern from the Local Storage
 */
const cleanLSSimilarKey = (text, LSKeys = '') => {
    if (checkDocument) {
        let newLSKeys;
        if (typeof LSKeys === 'string') {
            newLSKeys = LSKeys.split(',').join('|');
        }
        else {
            newLSKeys = LSKeys.join('|');
        }
        const matchRegex = new RegExp(`^(${newLSKeys})$`);
        Object.keys(window.localStorage).forEach(key => {
            if (key.startsWith(text) && !matchRegex.test(key)) {
                window.localStorage.removeItem(key);
            }
        });
    }
};
/**
 *
 * @param {String} text
 * @param {string, string[]} LSCurrent
 * @type Function
 * @description A function that extracts a set of keys matching a pattern from the Local Storage
 */
const getLSSimilarKey = (text, LSCurrent) => {
    let latestMatch = '';
    if (checkDocument) {
        if (typeof LSCurrent === 'string') {
            LSCurrent = LSCurrent.split(',').join('|');
        }
        else {
            LSCurrent = LSCurrent.join('|');
        }
        const matchRegex = new RegExp(`^(${LSCurrent})$`);
        Object.keys(window.localStorage).forEach(key => {
            if (key.startsWith(text) && !key.match(matchRegex)) {
                const datePart = key.split('~')[1];
                if (new Date(datePart) > new Date(latestMatch)) {
                    latestMatch = datePart;
                }
            }
        });
    }
    return latestMatch ? latestMatch : null;
};
/**
 *
 * @param {Function} fn Callback
 * @type Function
 * @description A function that executes a callback when document is ready.
 */
const docReady = (fn) => {
    if (checkDocument) {
        if (document.attachEvent
            ? document.readyState === 'complete'
            : document.readyState !== 'loading') {
            fn();
        }
        else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }
};
/**
 * @type Function
 * @description A function that returns which transitionEnd is available in the browser.
 */
const whichTransitionEndEvent = () => {
    if (checkDocument) {
        const el = document.createElement('fakeelement');
        const transitions = {
            transition: 'transitionend',
            OTransition: 'oTransitionEnd',
            MozTransition: 'transitionend',
            webkitTransition: 'webkitTransitionEnd',
        };
        const key = (Object.keys(transitions).find(t => el.style[t] !== undefined));
        return transitions[key];
    }
    return 'transitionend';
};
const getTransitionEndEvent = whichTransitionEndEvent();
/**
 * @type Function
 * @description A function that returns which animationEnd event needs to be executed.
 */
const whichAnimationEndEvent = () => {
    if (checkDocument) {
        const el = document.createElement('fakeelement');
        const animations = {
            animation: 'animationend',
            OAnimation: 'oAnimationEnd',
            MozAnimation: 'animationend',
            WebkitAnimation: 'webkitAnimationEnd',
        };
        const key = (Object.keys(animations).find(t => el.style[t] !== undefined));
        return animations[key];
    }
    return 'animationend';
};
const getAnimationEndEvent = whichAnimationEndEvent();
/**
 * @description a function to do a hard reload on the page
 * @param type (optional) if `1` it ll do a soft reload, else hard reload
 */
const hardReload = (type) => {
    if (checkDocument) {
        if (type === 1) {
            window.location.reload();
        }
        else {
            window.location.reload(true);
        }
    }
};
/**
 * @description to check if native share is available or not
 */
const checkShareAvailable = checkDocument && typeof navigator.share !== 'undefined';
/**
 *
 * @param {Function} fn the animation function to be executed for each frame
 * @param {Number} init initial position
 * @param {Number} final final position
 * @param {Number} start position to start from
 * @param {Number} time total time the animation should take in ms
 * @param {Function} oneEnd callback function at the end of an animation
 * @param {Number} refreshRate refresh rate of the monitor (60 by default)
 * @type Function
 * @description A function that helps in executing animations.
 */
const smoothAnimate = (fn, init, final, start, time, oneEnd, refreshRate = 60) => {
    let rafVal;
    if (checkDocument && hasOwn(window, 'requestAnimationFrame')) {
        const rafFn = (curr = start) => {
            if ((final > init && curr < final) ||
                (final < init && curr > final)) {
                rafVal = requestAnimationFrame(() => {
                    fn(curr);
                    const newCurr = curr + (final - init) / (time * refreshRate);
                    rafFn(newCurr);
                });
            }
            if (typeof oneEnd === 'function' &&
                ((final > init && curr >= final) ||
                    (final < init && curr <= final))) {
                requestAnimationFrame(() => {
                    oneEnd();
                });
            }
        };
        rafFn();
    }
    else {
        fn(final);
    }
    return {
        getRafVal: () => rafVal,
    };
};
/**
 * @description used for creating a custom intersection observer (IO) function. https://www.smashingmagazine.com/2018/01/deferring-lazy-loading-intersection-observer-api/
 * @param {Function} onNonIntersect Function to be called when not intersecting
 * @param {Function} onIntersect Function to be called when intersecting
 * @param {Function} onNoIO Function to be called if theres no intersection observer
 * @param {Element} selectorElem element that needs to be monitored if its intersecting or not
 * @param {Element} watchingWrapper element (capturing frame) within which the element intersects. if nothing is passed, the viewport is assumed
 * @param {String} rootMargin set margins around the watching wrapper which when the selectorElem crosses would trigger an intersection
 * @param {number, number[]} threshold percentage of the selectorElem when intersected should trigger a reaction from the IObserver
 * @param {boolean} unobserveOnIntersect whether the IO should stop observing the selectorElem after intersection has taken place
 * @param {boolean} disconnectOnIntersect whether the IO should kill the observer on the selectorElem after intersection has taken place
 * @type Function
 */
const anythingObserver = (onNonIntersect = () => { }, onIntersect = () => { }, onNoIO = () => { }, selectorElem, watchingWrapper = undefined, rootMargin = '50px', threshold = 0, unobserveOnIntersect, disconnectOnIntersect) => {
    let ioObserver = null;
    if (checkDocument) {
        if ('IntersectionObserver' in window) {
            ioObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Stop watching and load the image
                        if (unobserveOnIntersect) {
                            ioObserver.unobserve(entry.target);
                        }
                        onIntersect();
                        if (disconnectOnIntersect) {
                            ioObserver.disconnect();
                        }
                        // entry.target.classList.add('c-lazyload--complete');
                    }
                    else {
                        onNonIntersect();
                    }
                });
            }, {
                root: watchingWrapper,
                rootMargin,
                threshold,
            });
        }
    }
    if (!ioObserver) {
        onNoIO();
    }
    else {
        ioObserver.observe(selectorElem);
    }
    return {
        observerVal: ioObserver,
        destroy: () => {
            if (ioObserver && typeof ioObserver.disconnect !== 'undefined') {
                ioObserver.disconnect();
            }
        },
    };
};
/**
 * @description Lazyloader for images
 * @param image Image element
 * @param action function to execute on intersection
 * @param rootSelector watching wrapper (capturing frame)
 */
const imgObserver = (image, action, rootSelector = undefined) => anythingObserver(undefined, // onNonIntersect = () => {},
action, // onIntersect,
action, // onNoIO = () => {},
image, // selectorElem,
rootSelector, // watchingWrapper,
undefined, // rootMargin = '50px',
undefined, // threshold = 0,
true, // unobserveOnIntersect,
true // disconnectOnIntersect
);

export { CookieControl, GetURLParams, Harpic, TabFocusCheck, anythingObserver, asyncForEach, camelToSentence, checkDocument, checkSMHD, checkShareAvailable, cleanLSSimilarKey, compareVersion, dateFromString, debounce, decimalTrimmer, decimalTrimmer2, delegateClass, delegateSelector, docReady, fileInputChecker, generateQrCode, generateRandomNumber, getAnimationEndEvent, getBrowserNVersion, getDateFromDayOfMonth, getLSSimilarKey, getMobileOperatingSystem, getScrollbarWidth, getTransitionEndEvent, hardReload, hasOwn, imgObserver, inrConverter, intNumberConverter, measureTime, memoized, moneyFormatter, onlineStatusInstance, requestIdleCb, scientificToDecimal, smoothAnimate, userAgent, waitMaadi };
